/**
 * GNOME Shell integration
 *
 * Declares a single web-accessible resource, `include/sweettooth-api.js`, scoped to the
 * GNOME extensions site (`https://extensions.gnome.org/*` and
 * `https://extensions-next.gnome.org/*`) rather than to every origin. The script is
 * genuinely unreachable from anywhere else, so a negative result off those sites says
 * nothing — only that origin can detect it. From extensions.gnome.org the vendor-named
 * script is served at a fixed URL, making the fetch conclusive.
 *
 * Manifest verified against version 12.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gphhapmejobijbbhgpjhcjognlahblep';

export const gnomeShellIntegration: ExtensionDefinition = {
  id: ID,
  name: 'GNOME Shell integration',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  requiredOrigin: 'https://extensions.gnome.org',
  notes:
    'Single WAR (include/sweettooth-api.js) scoped to extensions.gnome.org, so only that ' +
    'origin can detect it — a negative result elsewhere is inconclusive. On-site it is conclusive.',
  signals: [
    {
      id: 'war-sweettooth-api-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch include/sweettooth-api.js — the vendor-named SweetTooth API bridge, ' +
        'static but only exposed to the GNOME extensions site origins.',
      weight: 1,
      run: () => probeFetch(ID, 'include/sweettooth-api.js'),
    },
  ],
};
